import type { ListCreditsResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { subscriptionKeys } from "@/hooks/queryKeys";

export function useCredits(): UseQueryResult<ListCreditsResponse> {
  return useQuery({
    queryFn: () => MOCK_CREDITS,
    queryKey: subscriptionKeys.credits(),
    staleTime: Infinity,
  });
}

const MOCK_CREDITS: ListCreditsResponse = [
  {
    account: { name: "Northstar Legal Group", projectId: 4102 },
    applied: "0.00",
    currency: "USD",
    id: "cr_northstar_plan_change",
    issued: "120.00",
    issuedBy: null,
    issuedOn: "2026-08-01",
    note: "Slot reduction 8 to 6. Applied at next cycle, not refunded",
    reason: "plan-change",
    remaining: "120.00",
    sourceInvoiceId: "INV-20260720-000027-4102",
  },
  {
    account: { name: "Brightline Studio", projectId: 3871 },
    applied: "0.00",
    currency: "USD",
    id: "cr_brightline_turnaround",
    issued: "150.00",
    issuedBy: "Vanessa B.",
    issuedOn: "2026-07-24",
    note: "3 requests missed committed turnaround",
    reason: "turnaround-delay",
    remaining: "150.00",
    sourceInvoiceId: "INV-20260620-000026-3871",
  },
  {
    account: { name: "Vela Goods", projectId: 4417 },
    applied: "0.00",
    currency: "USD",
    id: "cr_vela_goodwill",
    issued: "200.00",
    issuedBy: "Vanessa B.",
    issuedOn: "2026-07-15",
    note: "Goodwill during the platform migration",
    reason: "goodwill",
    remaining: "200.00",
    sourceInvoiceId: "INV-20260620-000026-4417",
  },
  {
    account: { name: "Harbor & Co.", projectId: 2950 },
    applied: "250.00",
    currency: "USD",
    id: "cr_harbor_turnaround",
    issued: "400.00",
    issuedBy: "Vanessa B.",
    issuedOn: "2026-06-03",
    note: "Two SLA misses in May",
    reason: "turnaround-delay",
    remaining: "150.00",
    sourceInvoiceId: "INV-20260520-000025-2950",
  },
  {
    account: { name: "Pinecrest Labs", projectId: 3324 },
    applied: "75.00",
    currency: "USD",
    id: "cr_pinecrest_other",
    issued: "75.00",
    issuedBy: "Vanessa B.",
    issuedOn: "2026-05-19",
    note: "Referral",
    reason: "other",
    remaining: "0.00",
    sourceInvoiceId: "INV-20260420-000024-3324",
  },
  {
    account: { name: "Harbor & Co.", projectId: 2950 },
    applied: "0.00",
    currency: "USD",
    id: "cr_harbor_qa_issue",
    issued: "300.00",
    issuedBy: "Vanessa B.",
    issuedOn: "2026-04-28",
    note: "",
    reason: "qa-issue",
    remaining: "300.00",
    sourceInvoiceId: "INV-20260320-000023-2950",
  },
];
